import { render } from "./DeviceFrame.vue?vue&type=template&id=30b988a4&scoped=true"
import script from "./DeviceFrame.vue?vue&type=script&lang=js"
export * from "./DeviceFrame.vue?vue&type=script&lang=js"

import "./DeviceFrame.vue?vue&type=style&index=0&id=30b988a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b988a4"]])

export default __exports__